import {
  LetterbookLibraryType,
  LetterlistTableColumnSettingType,
} from "features/Letterbooks/types";
import LetterbookCell from "../LetterbookCell";
import useCurrentUserId from "hooks/user/useCurrentUserId";
import EditableDatesRead from "features/books/components/UserBookPanel/EditableDatesRead/EditableDatesRead";
import Button from "hardcover-ui/components/Button";
import useUserBookService from "services/UserBookService/useUserBookService";

function EditableOwnerDatesRead({
  letterbook,
}: {
  letterbook: LetterbookLibraryType;
}) {
  const { insertDateRead } = useUserBookService(letterbook.book.id);

  return (
    <div className="flex flex-col items-start gap-2">
      <EditableDatesRead book={letterbook.book} />

      <div className="mt-2 flex justify-between">
        <Button onClick={() => insertDateRead()} variant="ghost" size="sm">
          + Add New Read
        </Button>
      </div>
    </div>
  );
}

export default function OwnerDatesReadColumn({
  letterbook,
}: {
  letterbook: LetterbookLibraryType;
}) {
  const currentUserId = useCurrentUserId();
  const isOwner = letterbook.data.ownerUserBook.userId === currentUserId;
  return (
    <LetterbookCell className="font-bold text-xl">
      { isOwner ? (
        <EditableOwnerDatesRead letterbook={letterbook} />
      ) : (
        <div className="flex items-center">
          <p>Not editable dates read</p>
        </div>
      )}
    </LetterbookCell>
  );
}

export const settings = {
  key: "OwnerDatesRead",
  title: "Dates Read",
} as LetterlistTableColumnSettingType;
